module.exports = __webpack_public_path__ + "static/media/header_search_icon.820c2cd8.svg";